module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-5.8f7eca58.png";